/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdMenuGroupProps } from '../menu/type';
import { PropType } from 'vue';

export default {
  /** 菜单组标题 */
  title: {
    type: [String, Function] as PropType<TdMenuGroupProps['title']>,
  },
};
